"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _responsiveBreakpoints = _interopRequireDefault(require("ui-addon-upgrades/_core/utils/responsiveBreakpoints"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 25px;\n    padding-right: 30px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "FooterMicrocopy__FooterWrapper",
  componentId: "s6h37i-0"
})(["position:relative;padding-top:16px;padding-bottom:20px;z-index:1;color:", ";font-size:12px;clear:both;", ""], _colors.SLINKY, _responsiveBreakpoints.default.tablet(_templateObject()));

var FooterMicrocopy = function FooterMicrocopy() {
  var handleClickLink = function handleClickLink() {
    tracker.track('externalLinkClick', {
      name: 'product-services-catalog'
    });
  };

  return _react.default.createElement(FooterWrapper, {
    className: "text-center flex-column"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "upgrades.productCatalog.footer.productServicesCatalogPrompt_jsx",
    options: {
      onClick: handleClickLink
    },
    elements: {
      UILink: _UILink.default
    }
  }));
};

var _default = FooterMicrocopy;
exports.default = _default;
module.exports = exports.default;